import { useTranslation } from 'react-i18next';

import type { Contact } from '~/api/clients/types';

import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { emailListStyle, moreEmailsStyle } from './contactCell.css';

type Props = {
  contact: Contact;
};

export const ContactEmailsCell = ({ contact }: Props) => {
  const { t } = useTranslation(['clients']);

  if (contact.emails.length === 0) return '-';

  return (
    <ul className={emailListStyle}>
      {contact.emails.slice(0, contact.emails.length > 3 ? 2 : 3).map(({ email, type }, i) => (
        <li className={desktopTruncateStyle} key={i}>
          {type === 'client' ? email : t('clients:detail.contacts.selfEmail', { email })}
        </li>
      ))}

      {contact.emails.length > 3 && (
        <li className={clsx(moreEmailsStyle, desktopTruncateStyle)}>
          {t('clients:detail.contacts.moreEmails', { amount: contact.emails.length - 2 })}
        </li>
      )}
    </ul>
  );
};
